// extracted by mini-css-extract-plugin
export default {"tupacGrid":"hm-z","tupacHeader":"im-z","tupacHeader2":"jm-z","tupacMenu":"km-z","tupacMenu2":"lm-z","tupacMain":"mm-z","tupacMain2":"nm-z"};